export const CHART_HISTORY_EDGE_THRESHOLD = 32;

export const shouldRequestChartHistory = ({
  range,
  pointCount,
  hasMore,
  loading,
  threshold = CHART_HISTORY_EDGE_THRESHOLD,
}) => {
  if (!hasMore || loading || !range) return false;
  if (!Number.isFinite(Number(range.from)) || !Number.isFinite(Number(range.to))) {
    return false;
  }
  if (!Number.isFinite(Number(pointCount)) || Number(pointCount) <= 0) return false;

  return Number(range.from) <= Number(threshold);
};
